"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NDSLib", {
  enumerable: true,
  get: function get() {
    return _ndsLib.default;
  }
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _unescape = _interopRequireDefault(require("unescape"));

var _nodeToNdsComponent = _interopRequireDefault(require("./lib/node-to-nds-component"));

var _ndsLib = _interopRequireDefault(require("./lib/nds-lib"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HtmlToNds = function HtmlToNds(_ref) {
  var html = _ref.html,
      decode = _ref.decode,
      componentDict = _ref.componentDict,
      forceWhitelist = _ref.forceWhitelist;
  return _react.default.createElement("div", null, (0, _htmlReactParser.default)(decode ? (0, _unescape.default)(html) : html, {
    replace: (0, _nodeToNdsComponent.default)(componentDict, forceWhitelist)
  }));
};

HtmlToNds.propTypes = {
  html: _propTypes.default.string.isRequired,

  /**
   * Flag to indicate the component should convert HTML entities to HTML characters
   * e.g. &gt; converts to >
   * Inefficient, and not recommended -- rather explicitly add expected entities to `componentDict` prop
   */
  decode: _propTypes.default.bool,

  /**
   * Flag to indicate the component should explicitly whitelist the contents of `componentDict`
   */
  forceWhitelist: _propTypes.default.bool,

  /**
   * Object that provides custom function mappings for HTML node conversion
   */
  componentDict: _propTypes.default.objectOf(_propTypes.default.func)
};
HtmlToNds.defaultProps = {
  decode: false,
  forceWhitelist: false,
  componentDict: {}
};
var _default = HtmlToNds;
exports.default = _default;
HtmlToNds.__docgenInfo = {
  "description": "",
  "displayName": "HtmlToNds",
  "props": {
    "html": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "decode": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Flag to indicate the component should convert HTML entities to HTML characters\ne.g. &gt; converts to >\nInefficient, and not recommended -- rather explicitly add expected entities to `componentDict` prop",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "forceWhitelist": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Flag to indicate the component should explicitly whitelist the contents of `componentDict`",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "componentDict": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "func"
        }
      },
      "required": false,
      "description": "Object that provides custom function mappings for HTML node conversion",
      "defaultValue": {
        "value": "{}",
        "computed": false
      }
    }
  }
};